import React from 'react'
import { useTranslation } from 'i18n'
import * as styles from '../SideBySideVideo.module.scss'
import { ArrowLeftIcon } from 'lucide-react'

type Props = {
  step: number
  total: number
  onBack?: () => void
  showBack?: boolean
}

const StepHeader = ({ step, total, onBack, showBack = true }: Props) => {
  const { t } = useTranslation(['sideBySideVideo', 'common'])

  return (
    <div className={styles.header}>
      {showBack ? (
        <button
          type="button"
          className={styles.back}
          onClick={onBack}
          aria-label={t('common:back')}
        >
          <ArrowLeftIcon size={16} /> {t('common:back')}
        </button>
      ) : (
        <span />
      )}
      <div className={styles.stepper}>
        <span className={styles.stepperLabel}>
          {t('common:stepCounter', { current: step, total })}
        </span>
        <span className={styles.stepperDots}>
          {Array.from({ length: total }).map((_, i) => (
            <span
              key={i}
              className={[
                styles.stepperDot,
                i + 1 === step
                  ? styles.isActive
                  : i + 1 < step
                  ? styles.isDone
                  : '',
              ]
                .filter(Boolean)
                .join(' ')}
            />
          ))}
        </span>
      </div>
      <span />
    </div>
  )
}

export default StepHeader
